import { render, staticRenderFns } from "./dehorningBetweenTwoDays.vue?vue&type=template&id=4c5d06fb&scoped=true&"
import script from "./dehorningBetweenTwoDays.vue?vue&type=script&lang=js&"
export * from "./dehorningBetweenTwoDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d06fb",
  null
  
)

export default component.exports